import React from "react";
import { MainHseForm } from "./main-hse";

export const MainAgendes: React.FC = (): React.ReactElement => {
  return <MainHseForm />;
};
